import { CheckCircle, Pencil, PlusCircle, Trash2 } from "lucide-react";
import { FC, useEffect, useState } from "react";
import { BauStein } from "../../Store/interfaces";
import { Colors } from "../../Styles/colors";

interface BS_TextAreaProps {
  baustein: BauStein;
  onDelete: (id: string) => void;
  onAdd: (bs: BauStein) => void;
  onChange: (id: string, bs: BauStein) => void;
  onPress: (text: string) => void;
  onCheck: (hasValues: boolean) => void; // gibt an ob etwas im titel oder inhalt vom editableBaustein eingetippt wurde
}

const BauSteinUi: FC<BS_TextAreaProps> = ({
  baustein,
  onDelete,
  onAdd,
  onChange,
  onPress,
  onCheck,
}) => {
  const [editableBaustein, setEditableBaustein] = useState<BauStein>(baustein);
  const [isEditable, setIsEditable] = useState(false);

  const [startsEmpty, setStartsEmpty] = useState(false);

  useEffect(() => {
    let hasValues = false;
    if (startsEmpty) {
      hasValues =
        editableBaustein.titel.length > 0 || editableBaustein.inhalt.length > 0;

      if (hasValues) {
        onCheck(hasValues); // Notify parent component
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableBaustein, onCheck]);

  function onAcceptChange() {
    setIsEditable(false);
    onChange(baustein.id, editableBaustein);
  }

  function onAddPressed() {
    onAdd(editableBaustein);
    setEditableBaustein({
      titel: "",
      inhalt: "",
      id: "",
    });
  }

  return (
    <div className="flex flex-col whitespace-pre-line sm:flex-row items-center bg-gray-200 rounded-lg p-2.5 w-full">
      {(isEditable || baustein.id.length === 0) && (
        <div className="flex flex-col sm:flex-row justify-between w-full gap-3">
          <input
            className="input input-bordered w-full sm:w-1/3 rounded-lg p-2"
            placeholder="Bezeichnung"
            value={editableBaustein.titel}
            onChange={(e) => {
              setEditableBaustein((prevBaustein) => ({
                ...prevBaustein,
                titel: e.target.value,
              }));
            }}
          />
          <textarea
            className="textarea textarea-bordered w-full sm:w-2/3 p-2 rounded-lg"
            placeholder="Inhalt vom Textbaustein..."
            value={editableBaustein.inhalt}
            onChange={(e) => {
              setEditableBaustein((prevBaustein) => ({
                ...prevBaustein,
                inhalt: e.target.value,
              }));
            }}
            rows={editableBaustein.inhalt.split("\n").length}
          />
        </div>
      )}
      {!isEditable && baustein.id.length !== 0 && (
        <div
          className="flex flex-col sm:flex-row justify-between w-full cursor-pointer gap-3"
          onClick={() => onPress(editableBaustein.inhalt)}
        >
          <div className="w-full sm:w-1/3 text-left font-semibold font-sans">
            {baustein.titel}
          </div>
          <span className="w-full whitespace-pre-line sm:w-2/3 text-left ">
            {editableBaustein.inhalt}
          </span>
        </div>
      )}
      <div className="flex items-center mt-3 sm:mt-0 sm:ml-auto">
        {!isEditable && baustein.id.length !== 0 && (
          <button
            onClick={() => setIsEditable(!isEditable)}
            className="btn btn-ghost"
          >
            <Pencil size={20} />
          </button>
        )}
        {isEditable && (
          <>
            <button
              onClick={() => onDelete(baustein.id)}
              className="btn btn-ghost ml-3"
            >
              <Trash2 size={20} />
            </button>
            <button onClick={onAcceptChange} className="btn btn-ghost ml-2">
              <CheckCircle size={20} />
            </button>
          </>
        )}
        {baustein.id.length === 0 && (
          <button onClick={onAddPressed} className="btn btn-ghost">
            <PlusCircle size={24} color={Colors.blue_royal} />
          </button>
        )}
      </div>
    </div>
  );
};

export default BauSteinUi;
